import { useAsyncData } from 'modules/core/hooks/useAsyncData'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'

import StepApprovers from 'modules/approvals/store/collections/stepApprovers'

interface UseStepApprovers {
  approvalFlowId?: number | null
}

export const useStepApprovers = ({ approvalFlowId }: UseStepApprovers) => {
  const stepApprovers = useLazyRef(() => new StepApprovers()).current

  const { loading } = useAsyncData(async () => {
    if (!approvalFlowId || stepApprovers.models.length) return Promise.resolve()
    return stepApprovers.fetch({ data: { approval_flow_ids: [approvalFlowId] } })
  }, [approvalFlowId])

  return { loading, stepApprovers: stepApprovers.models }
}
